
import Component from '../../../assets/scripts/modules/component'
import { cubicOut } from '../../../assets/scripts/utilities/easings'

const COUNT_DURATION = 3000

const formatNumber = (value, max) => value.toLocaleString(document.documentElement.lang)

export default class CampaignSpreadComponent extends Component {
  async init () {
    this.countContainer = this.element.querySelector('.campaign-spread__count')
    this.progress = this.element.querySelector('.campaign-spread__count-progress')
    this.counter = this.element.querySelector('.campaign-spread__count-value')

    if (!this.countContainer || !this.progress || !this.counter) {
      return
    }

    this.progressMin = 0
    this.progressMax = 0
    this.progressStep = 0
    this.progressCount = 0
    this.progressValue = 0
    this.progressTimeout = null

    window.addEventListener('init-after-load', () => this.initProgress())
  }

  initProgress () {
    this.progressMax = this.progress.max
    this.progressValue = parseInt(this.progress.getAttribute('data-value'), 10)
    this.progressStep = this.progressValue / COUNT_DURATION * 16.667 // 16.667 is one animation frame

    this.progress.min = this.progressMin
    this.progress.max = this.progressMax

    if (this.counter) {
      this.counter.style.width = this.counter.offsetWidth + 'px'
    }

    this.progress.value = this.progressCount

    if (this.counter) {
      this.counter.innerText = formatNumber(this.progressCount, this.progressMax)
    }

    this.countContainer.classList.add('campaign-spread__count--visible')

    if (this.progressValue < 1 || this.progressMax < 1) {
      return
    }

    window.requestAnimationFrame(() => this.updateProgress())
  }

  updateProgress () {
    this.progressCount += this.progressStep
    this.progressCount = Math.ceil(Math.min(this.progressCount, this.progressMax))

    const easing = cubicOut(1 / this.progressValue * this.progressCount)
    const easedCount = Math.round(this.progressValue * easing)

    this.progress.value = easedCount

    if (this.counter) {
      this.counter.innerText = formatNumber(easedCount, this.progressMax)
    }

    if (this.progressCount < this.progressValue) {
      window.requestAnimationFrame(() => this.updateProgress())
    } else {
      if (this.counter) {
        this.counter.style.width = null
      }
    }
  }
}

window.addEventListener('init-load', () => document.querySelectorAll('.campaign-spread').forEach(element => {
  element.instance = element.instance || new CampaignSpreadComponent(element)
}))
